<unity-control-wrapper [control]="$control()" [description]="$description()" [displayName]="$displayName()" [showHint]="$showHint()">
  <kendo-maskedtextbox mask="(000) 000-0000" [formControl]="$control()" />
</unity-control-wrapper>
